var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8923 8.86603L11.3923 9.73205C12.7256 8.96225 12.7256 7.03775 11.3923 6.26795L4 2C2.66667 1.2302 0.999999 2.19245 0.999999 3.73205L0.999999 12.2679C0.999999 13.8075 2.66667 14.7698 4 14L11.3923 9.73205L10.8923 8.86603Z",
    fill: "#C1D7FF",
    stroke: "#4A54D3",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueArrow);
export default __webpack_public_path__ + "static/media/blue-arrow.42d93ab92888dea1c935366c1bba27a0.svg";
export { ForwardRef as ReactComponent };